import { AbstractControl,ValidationErrors, ValidatorFn } from '@angular/forms';

export function atLeastOneValidator(properties: string[]) : ValidatorFn{

    return (control: AbstractControl): ValidationErrors | null => {
        let pass = false;

        properties.forEach( p =>{
            const c = control.get(p);
            const hasValue = c && c.value !== null && c.value !== undefined && c.value !== '';
            pass = pass || !!hasValue;
        });

        return pass ? null : { atLeastOneFail: true };
    };

};